module.exports = __webpack_public_path__ + "static/media/dsr_journey5.b02ea820.svg";